export function getPerformanceNow(): number {
    if (self.performance) {
        return self.performance.now();
    }
    return Date.now();
}
